export default "__VITE_ASSET__vkqlZuOK__"